import { Fragment, useContext, useEffect, useState } from "react";
import { Card, BaseTable, Loading, DateInput, Select, TableNumber, PermissionLink, PaginationData, TableSorting, TableHeaderSort } from "components";
import moment from "moment";
import { useLocation } from "../../../Sales/Register/components/TabLocation/utils/hooks/useLocation";
import { useList } from "./utils";
import { convertNumber } from "utils";
import { Delete } from "./components";
import { IoSendSharp } from "react-icons/io5";
import { DataContext } from "../utils/contexts";
import { FilterColumn } from "../components";
import { CountList } from "./type";
import { PERMISION } from "security";

export type FillterType = {
  start_date?: string;
  end_date?: string;
  location_id?: string;
  status_id?: string;
  total: number,
  page: number,
  limit: number,
  pages: number,
  keyword: string,
};
const defaultFilter = {
  start_date: moment().startOf('month').format("YYYY-MM-DD"),
  end_date: moment().endOf('month').format("YYYY-MM-DD"),
  total: 0,
  page: 1,
  limit: 10,
  pages: 1,
  keyword: '',
  location_id: '',
  status_id: '',
}

const getStatusLabel = (status?: number): string => {
  const statusMap: Record<number, string> = {
    1: "Count",
    2: "Adjustment",
    3: "Complete",
  };
  return status ? statusMap[status] || "-" : "-";
};

export function ItemsCount(): JSX.Element {
  const [pagination, setPagination] = useState<FillterType>(defaultFilter);
  const { data, isLoading, refetch } = useList(pagination);

  const allOption = { value: "", label: "ALL" }
  const dataStatus = [
    allOption,
    { value: "1", label: "Count" },
    { value: "2", label: "Adjustment" },
    { value: "3", label: "Complete" },
  ];

  const { dataLocation, isLoadingLocation } = useLocation()

  const { setFill, setActiveColumn } = useContext(DataContext);

  const header: TableSorting[] = [
    { title: "COUNT ID#", value: "trx_code", isActive: true },
    { title: "DATE", value: "transaction_date", isActive: true },
    { title: "LOCATION", value: "location_name", isActive: true },
    { title: "TRADER", value: "employee_name", isActive: true },
    { title: "STATUS", value: "status", isActive: true },
    { title: "MEMO", value: "memo", isActive: true },
    { title: "SOH", value: "soh", isActive: true },
    { title: "COUNT", value: "count", isActive: true },
    { title: "DIFFERENCE", value: "difference", isActive: true },
  ]

  const [tableActive, setTableActive] = useState<TableSorting[]>(header);


  useEffect(() => {
    setActiveColumn && setActiveColumn(tableActive);
    setFill({ 
        dateFrom: pagination.start_date, 
        dateTo: pagination.end_date,
        location_id: pagination.location_id, 
        count_status: pagination.status_id
    });
  }, [
    setFill,
    pagination.start_date,
    pagination.end_date,
    pagination.location_id,
    pagination.status_id,
    setActiveColumn,
    tableActive
  ]);

  return (
    <Fragment>
      <section className="my-2">
        <section className="flex flex-col gap-3">
          <Card>
            <Card.Body>
              <section className="lg:flex lg:items-end gap-3 mt-2 w-full">
                <DateInput
                  label="START DATE"
                  wrapperClassName="lg:w-[180px]"
                  onChange={(date) => setPagination({ ...pagination, start_date: moment(date).format("YYYY-MM-DD") })}
                  selected={pagination.start_date ? moment(pagination.start_date).toDate() : null}
                />

                <DateInput
                  label="END DATE"
                  wrapperClassName="lg:w-[180px]"
                  onChange={(date) => setPagination({ ...pagination, end_date: moment(date).format("YYYY-MM-DD") })}
                  selected={pagination.end_date ? moment(pagination.end_date).toDate() : null}
                />

                <Select
                  width
                  label="LOCATION"
                  controlClass="lg:w-[180px]"
                  isLoading={isLoadingLocation}
                  value={pagination?.location_id !== "" ? [allOption, ...dataLocation].find((item) => item.value?.toString() === pagination?.location_id?.toString()) : allOption}
                  options={[allOption, ...dataLocation]}
                  onChange={(e) => setPagination({ ...pagination, location_id: e?.value! })}
                />

                <Select
                  width
                  label="STATUS"
                  controlClass="lg:w-[180px]"
                  isLoading={isLoadingLocation}
                  value={pagination?.status_id !== "" ? dataStatus.find((item) => item.value?.toString() === pagination?.status_id?.toString()) : allOption}
                  options={dataStatus}
                  onChange={(e) => setPagination({ ...pagination, status_id: e?.value! })}
                />

                <FilterColumn dataFilter={tableActive} setTableActive={setTableActive} />
              </section>
            </Card.Body>
          </Card>

          <Card>
            <Card.Body>
              <div className="overflow-auto max-h-[calc(100vh-600px)]">
                <BaseTable className="border-collapse">
                  <thead className="bg-white sticky top-0 z-[0] !bg-black !text-white">
                    <tr>
                      <th>NO</th>

                      <TableHeaderSort
                        title={tableActive}
                      />

                      <th>ACTION</th>
                    </tr>
                  </thead>

                  <tbody>
                    {isLoading || data.payload.length === 0 ? (
                      <tr>
                        <td colSpan={11} className="text-center">
                          <Loading loading={isLoading} errorText="No data available" />
                        </td>
                      </tr>
                    ) : (
                      <Fragment>
                        {data?.payload?.map((item, key) => (
                          <tr>
                            <td className="text-center">
                              {TableNumber({
                                pageCurrent: pagination?.page!,
                                dataLength: pagination?.limit!,
                                index: key,
                                limit: pagination?.limit!,
                                totalData: pagination?.total!,
                              })}
                            </td>

                            {/* Kolom filter */}
                            {tableActive
                              .filter((col) => col.isActive !== false)
                              .map((col, idx) => (
                                <Fragment key={idx}>
                                  {renderCell(col.value!, item)}
                                </Fragment>
                              ))}
                              
                            <td>
                              <section className="join flex justify-center items-center gap-2">
                                <PermissionLink permission={PERMISION.INVENTORY.REGISTER.COUNT.UPDATE} to={`/inventory/transaction/count-inventory/edit/${item.count_id}`}>
                                  <IoSendSharp />
                                </PermissionLink>
                                {(Number(item.approve_status) === 4) ? ('') : (<Delete id={item} refetch={refetch} />)}
                              </section>
                            </td>
                          </tr>
                        ))}
                      </Fragment>
                    )}
                  </tbody>
                </BaseTable>

                <div className="mt-5">
                  <PaginationData
                    data={data}
                    pagination={pagination}
                    setPagination={setPagination}
                  />
                </div>
              </div>
            </Card.Body>
          </Card>
        </section>
      </section>
    </Fragment>
  );
}


function renderCell(value: string, item: CountList) {
  switch (value) {
    case "trx_code":
      return <td>{item?.trx_code}</td>
    case "transaction_date":
      return <td>{moment(item?.transaction_date).format("DD/MM/YYYY")}</td>
    case "location_name":
      return <td>{item?.location_name}</td>
    case "employee_name":
      return <td>{item?.employee_name}</td>
    case "status":
      return <td>{getStatusLabel(item?.count_status)}</td>
    case "memo":
      return <td>{item?.memo}</td>
    case "soh":
      return <td className="text-right">{item?.soh ? convertNumber(Number(item.soh)).intoCurrency : "-"}</td>
    case "count":
      return <td className="text-right">{item?.real_count ? convertNumber(Number(item.real_count)).intoCurrency : "-"}</td>
    case "difference":
      return <td className="text-right">{item?.different ? convertNumber(Number(item.different)).intoCurrency : "-"}</td>
    default:
      return <></>;
  }
}
